
import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import BasicSetupScreen from '@components/vehicle-setup/BasicSetupScreen.vue';

@Component({
  name: 'SetupStep4',
  components: {
    BasicSetupScreen,
  }
})
export default class SetupStep4 extends Vue {
  get publicFolder() {
    return process.env.BASE_URL;
  }
}
